import { render, staticRenderFns } from "./AddMemberForm.vue?vue&type=template&id=3bb56f38&"
import script from "./AddMemberForm.vue?vue&type=script&lang=js&"
export * from "./AddMemberForm.vue?vue&type=script&lang=js&"
import style0 from "./AddMemberForm.vue?vue&type=style&index=0&id=3bb56f38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports